<template>
  <div class="flex flex-col items-center mx-4 w-80">
    <div class="w-full flex flex-col items-center justify-center mb-4">
      <NegarCreditCardIcon size="72" class="mb-2 text-blue-primary" />

      <NText variant="body" weight="bold">
        {{ t('deposit.directDebit') }}
      </NText>
    </div>

    <ul class="marker:text-neutral-tertiary list-[square] list-inside">
      <template
        v-for="(description, index) of DIRECT_DEBIT_DESCRIPTIONS"
        :key="index"
      >
        <li>
          <NText
            variant="caption1"
            weight="medium"
            class="text-neutral-secondary"
          >
            {{ description }}
          </NText>
        </li>
      </template>
    </ul>

    <!--    change link of more information   -->
    <!--    <a-->
    <!--      v-if="isActiveDirectDebit"-->
    <!--      v-gid="{-->
    <!--        module: 'cash',-->
    <!--        screen: 'home',-->
    <!--        section: 'directDebitDescriptionDialog',-->
    <!--        component: `moreInfoLink`,-->
    <!--      }"-->
    <!--      :href="ACTIVATE_DIRECT_DEBIT_LINK"-->
    <!--      class="mt-1 mx-auto"-->
    <!--    >-->
    <!--      <NButton variant="flat" color="gray">-->
    <!--        <NegarLinkIcon />-->
    <!--        <NText variant="caption1" weight="bold">-->
    <!--          {{ t('common.moreInformation') }}-->
    <!--        </NText>-->
    <!--      </NButton>-->
    <!--    </a>-->

    <a
      v-if="!isActiveDirectDebit"
      v-gid="{
        module: 'cash',
        screen: 'home',
        section: 'directDebitDescriptionDialog',
        component: `activateLink`,
      }"
      :href="ACTIVATE_DIRECT_DEBIT_LINK"
      class="mt-1 w-full"
    >
      <NButton variant="flat" class="w-full">
        <NText variant="caption1" weight="bold">
          {{ t('deposit.activateDirectDebit') }}
        </NText>
      </NButton>
    </a>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { NegarCreditCardIcon } from '@negar/icons';
import { ACTIVATE_DIRECT_DEBIT_LINK } from '@core/cash';

type DirectDebitDescriptionProps = {
  isActiveDirectDebit: boolean;
};

defineProps<DirectDebitDescriptionProps>();

const { t } = useI18n();

const DIRECT_DEBIT_DESCRIPTIONS = [
  t('deposit.directDebitDescriptions.depositFromBank'),
  t('deposit.directDebitDescriptions.maxAmount'),
  t('deposit.directDebitDescriptions.availableBanks'),
  t('deposit.directDebitDescriptions.cancelDirectDebit'),
];
</script>
